import React, { CSSProperties, FC } from 'react';
import { SYSTEM_FONTS } from '../../styles/typography';

interface Props {
  bulletItems: string[];
  svg: string;
  containerStyle?: CSSProperties;
  textStyle?: CSSProperties;
  svgStyle?: CSSProperties;
  wrapperStyle?: CSSProperties;
}

const ImageTextBulletItems: FC<Props> = ({
  bulletItems,
  svg: Svg,
  containerStyle,
  textStyle,
  svgStyle,
  wrapperStyle,
}) => (
  <div
    css={[
      {
        display: 'flex',
        textAlign: 'center',
        width: '100%',
        justifyContent: 'center',
        maxWidth: 600,
        ...containerStyle,
      },
    ]}
  >
    <p
      css={{
        color: 'grey',
        fontFamily: ['Hero New'].concat(SYSTEM_FONTS).join(', '),
        fontWeight: 400,
        fontSize: 16,
        textAlign: 'center',
        justifyContent: 'center',
        ...textStyle,
      }}
    >
      {bulletItems.map((item) => (
        <span
          key={item}
          css={{
            marginRight: '1.5rem',
            whiteSpace: 'nowrap',
            'first-of-type': {
              marginLeft: 0,
            },
            ...wrapperStyle,
          }}
        >
          <Svg
            css={(theme) => ({
              position: 'relative',
              top: 4,
              marginRight: 5,
              color: theme.colors.primary,
              ...svgStyle,
            })}
          />
          <span>{item}</span>
        </span>
      ))}
    </p>
  </div>
);

export default ImageTextBulletItems;
